import { Component, OnInit } from '@angular/core';
import {CopyleaksReportConfig,CopyleaksService} from '../../../../client/projects/plagiarism-report/src/lib/plagiarism-report/copyleaks-report.module';
import { CopyleaksServiceHelper } from 'src/app/services/copyleaks.service';
import { ActivatedRoute } from '@angular/router';
import { Observable, combineLatestWith } from 'rxjs';
import { UserTypes } from 'src/app/models/userTypes';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CopyleaksReportComponent } from '../../../../client/projects/plagiarism-report/src/lib/plagiarism-report/copyleaks-report.component';

@Component({
    selector: 'app-compare',
    templateUrl: './compare.component.html',
    styleUrls: ['./compare.component.css'],
    imports: [NgIf, MatProgressSpinner, CopyleaksReportComponent]
})
export class CompareComponent implements OnInit {

  config: CopyleaksReportConfig = {};

  attachment2: any;
  attachment1: any;
  studentId: any;
  scanId: any;

  isEvaluator: boolean = false;
  isAdmin: boolean = false;
  isCurrentStudent: boolean = false;

  initialResults: any;
  currentScore: number = 0;
  filteredResults$: Observable<String[]> = this.copyLeaks.filteredResultsIds$;
  scoreUpdates$: Observable<number> = this.copyLeaks.scoreUpdate$;

  waitForResults: boolean = false;
  attachmentResultId: any;

  results: any;
  viewMode: any;
  noMatchMessage:boolean = false;

  role:UserTypes = UserTypes.EMA;

  constructor(
      private copyLeaks: CopyleaksService,
      private copyleaksServiceHelper: CopyleaksServiceHelper,
      private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.attachment2 = this.route.snapshot.params['attachment2'];
    this.attachment1 = this.route.snapshot.params['attachment1'];    
    this.buildCopyleaksReport();

  }

  initializeConfig(){

    this.config = {
      contentMode: "text",
      download: false,
      help: false,
      disableSuspectBackButton: false,
      propertiesExpanded: false,
      options: {
        showPageSources: false,
        showOnlyTopResults: false,
        showRelated: true,
        showIdentical: true,
        showMinorChanges: true,
        setAsDefault: false
      },
      share: false,
      suspectId: this.attachmentResultId,
      sourcePage: 1,
      suspectPage: 1,
      viewMode: this.viewMode 
    };


  }

  buildCopyleaksReport() {

    this.waitForResults = true;
    this.copyleaksServiceHelper.getComparison(this.attachment1, this.attachment2,this.role).subscribe((resp: any) => {
      this.scanId = resp.scannedDocument.scanId;
      this.studentId = this.scanId.split('_')[0];
      this.copyleaksServiceHelper.getSource(this.scanId,this.role).subscribe((resp: any) => {
        this.onPushDownloadedSource(resp);
      });
      this.onPushCompleteResult(resp);
      this.onGetResults(resp);
      this.initializeConfig();

      this.waitForResults = false;
    });
    
  }

  onPushDownloadedSource(crowledSource: any) {
    try{
      this.copyLeaks.pushDownloadedSource(crowledSource);
    }catch(error){
      console.log(error);
    }
  }

  onPushCompleteResult(completeResult: any) {
    try{
      completeResult.scannedDocument.creationTime = new Date().toISOString();

      this.copyLeaks.pushCompletedResult(completeResult);
    }catch(error){
      console.log(error);
    }

  }

  async onGetResults(completeResult: any) {
    try{
      let allResults = [
        ...completeResult.results.database.map((r:any) => r.id),
      ];

      this.results = allResults;

      let comparedResult = completeResult.results.database.find((result: any) => result.scanId.includes(`${this.studentId}_${this.attachment2}`));
      console.log(comparedResult);

      if(comparedResult !== undefined){
        this.attachmentResultId = comparedResult.id;
        this.viewMode = "one-to-one";
        
      }else{
        this.attachmentResultId = '';
        this.viewMode = "one-to-many";
        alert("No matches were found between the two compared files.");
      }

      allResults.map(async (id: any) => {

        if(this.isCurrentStudent){
          let scanResult: { result: undefined; id: any };
          scanResult = {
            id: id,
            result: undefined
          };
          this.copyLeaks.pushScanResult(scanResult);
        }else{
          this.onPushScanResults(id);
        }

      })
    }catch(error){
      console.log(error);
    }
  }

  onPushScanResults(id: string){
    this.copyleaksServiceHelper.getReport(this.scanId, id,this.role)
    .subscribe((result: any) => {
      let scanResult = {
        id: id,
        result: result
      }
      this.copyLeaks.pushScanResult(scanResult);
    });
  }
  close() {
    this.noMatchMessage = false;
  }
}
